import { Manufacturer, Media, ProductCategory } from '../payload-types';

export const isString = <T>(v: T | string): v is string => {
  return typeof v === 'string';
}

export const isNumber = <T>(v: T | number): v is number => {
  return typeof v === 'number';
}

export const isPresent = <T>(t: T | undefined | null | void): t is T => {
  return t !== undefined && t !== null;
}

export const isFilled = <T>(t: T | undefined | null | void | ''): t is T => {
  return t !== undefined && t !== null && t !== '';
}

export const isNotString = <T>(v: T | string): v is T => {
  return typeof v !== 'string';
}

/** A non-null, non-array object — a plain record with string keys. */
export const isRecord = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null && !Array.isArray(v);

export const isMedia = (v: undefined | null | string | Media): v is Media => !!v && !isString(v);

/**
 * A Media that will actually render an `<img>`: present AND carrying a resolvable
 * `url`. Stricter than {@link isMedia} — a Media whose `url` is null or empty (an
 * MCP-poisoned url, a stale/404 re-upload) renders nothing, so counting it as
 * present desyncs a hero's LCP-preload decision from what it actually paints. Use
 * it wherever the question is "will this image render", so the preload signal and
 * the render gate can never disagree.
 */
export const hasRenderableImage = (v: undefined | null | string | Media): v is Media & { url: string } =>
  isMedia(v) && isFilled(v.url);
export const isProductCategory = (v: undefined | null | string | ProductCategory): v is ProductCategory => !!v && !isString(v);
export const isManufacturer = (v: undefined | null | string | Manufacturer): v is Manufacturer => !!v && !isString(v);
